import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import { useAlertModal } from '../../AlertModalContext';

/* ── ícone reutilizável ── */
const Icon = ({ d, size = 16, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);

const ICONS = {
  info:    'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  plus:    'M12 4v16m8-8H4',
  refresh: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
  trash:   'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
  money:   'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  empty:   'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
};

/* ── helpers de estilo ── */
const inputStyle = {
  width: '100%', padding: '9px 12px', borderRadius: '8px',
  border: '1px solid #e5e7eb', fontSize: '13px', color: '#374151',
  fontFamily: "'Inter','Segoe UI',sans-serif", outline: 'none',
  backgroundColor: '#fff', boxSizing: 'border-box',
  transition: 'border-color 0.15s, box-shadow 0.15s',
};
const focusHandlers = {
  onFocus: e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.1)'; },
  onBlur:  e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; },
};
const FieldLabel = ({ children, required }) => (
  <label style={{ fontSize: '11px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '5px' }}>
    {children}{required && <span style={{ color: '#ef4444', marginLeft: '2px' }}>*</span>}
  </label>
);

const CATEGORIAS = [
  { value: 'aluguel_condominio',              label: 'Aluguel e Condomínio' },
  { value: 'agua_luz_telefone_internet',      label: 'Água, Luz, Telefone, Internet' },
  { value: 'marketing_publicidade',           label: 'Marketing e Publicidade' },
  { value: 'material_escritorio_limpeza',     label: 'Material Escritório/Limpeza' },
  { value: 'outras_despesas_administrativas', label: 'Outras Despesas Administrativas' },
];

const formatCategoria = v =>
  v.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

/* ════════════════════════════════════════════════════════ */

const LancamentoDespesasTab = ({ currentEntidade, formatCurrency, onDeleteClick, isActive }) => {
  const { showAlertModal } = useAlertModal();

  const [novaDespesa, setNovaDespesa] = useState({
    categoria:    'outras_despesas_administrativas',
    descricao:    '',
    valor:        '',
    data_despesa: new Date().toISOString().split('T')[0],
  });
  const [isSavingDespesa,          setIsSavingDespesa]          = useState(false);
  const [despesasLancadas,         setDespesasLancadas]         = useState([]);
  const [isLoadingDespesasLancadas, setIsLoadingDespesasLancadas] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setNovaDespesa(prev => ({ ...prev, [name]: value }));
  };

  const fetchDespesasLancadas = async () => {
    if (!currentEntidade) return;
    setIsLoadingDespesasLancadas(true);
    try {
      const res = await axios.get('/api/despesas-operacionais', {
        params: { entidade_id: currentEntidade.id },
      });
      setDespesasLancadas(res.data.despesas || []);
    } catch {
      setDespesasLancadas([]);
      showAlertModal('Erro', 'Não foi possível carregar as despesas recentes.', 'danger');
    } finally {
      setIsLoadingDespesasLancadas(false);
    }
  };

  const handleSalvar = async e => {
    e.preventDefault();
    if (!currentEntidade) { showAlertModal('Erro', 'Entidade não selecionada.', 'danger'); return; }
    setIsSavingDespesa(true);
    try {
      await axios.post('/api/despesas-operacionais', { ...novaDespesa, entidade_id: currentEntidade.id });
      showAlertModal('Sucesso', 'Despesa registrada com sucesso!', 'success');
      setNovaDespesa({
        categoria: 'outras_despesas_administrativas', descricao: '', valor: '',
        data_despesa: new Date().toISOString().split('T')[0],
      });
      fetchDespesasLancadas();
    } catch (err) {
// CORRETO
  showAlertModal('Erro', `Falha ao registrar despesa: ${err.response?.data?.message || err.message}`, 'danger');
    } finally {
      setIsSavingDespesa(false);
    }
  };

  useEffect(() => {
    if (isActive && currentEntidade) fetchDespesasLancadas();
  }, [isActive, currentEntidade]);

  /* ════════════════════ RENDER ════════════════════ */
  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .desp-table { width: 100%; border-collapse: collapse; }
        .desp-table th { padding: 10px 14px; font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 2px solid #e2e8f0; background: linear-gradient(135deg,#f8fafc,#f1f5f9); text-align: left; white-space: nowrap; }
        .desp-table td { padding: 11px 14px; font-size: 13px; color: #374151; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
        .desp-table tbody tr:hover { background: #fafbff; }
        @media (max-width: 575px) { .hide-xs { display: none !important; } }
        @media (max-width: 767px) { .hide-sm { display: none !important; } }
      `}</style>

      {/* ── CARD DE INFORMAÇÃO ── */}
      <div style={{
        backgroundColor: '#eff6ff', border: '1px solid #bfdbfe',
        borderRadius: '12px', padding: '16px 20px', marginBottom: '20px',
        display: 'flex', gap: '12px',
      }}>
        <div style={{ flexShrink: 0, marginTop: '1px' }}>
          <Icon d={ICONS.info} size={16} color="#2563eb" />
        </div>
        <div>
          <p style={{ margin: '0 0 4px', fontSize: '12px', fontWeight: '700', color: '#1e40af' }}>
            Para que serve esta funcionalidade?
          </p>
          <p style={{ margin: 0, fontSize: '12px', color: '#374151', lineHeight: '1.6' }}>
            Aqui você pode registrar os gastos mensais da sua entidade, como contas de água, luz, aluguel,
            marketing e outros custos operacionais. Manter esses registros atualizados é fundamental para
            a saúde financeira do seu negócio e para gerar relatórios precisos como o{' '}
            <strong>DRE</strong> (Demonstrativo de Resultado do Exercício).
          </p>
        </div>
      </div>

      {/* ── FORMULÁRIO: NOVA DESPESA ── */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px',
        border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '20px',
      }}>
        {/* Cabeçalho do card */}
        <div style={{
          padding: '14px 20px', borderBottom: '1px solid #e5e7eb',
          background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
          display: 'flex', alignItems: 'center', gap: '8px',
        }}>
          <Icon d={ICONS.money} size={15} color="#2563eb" />
          <span style={{ fontSize: '13px', fontWeight: '700', color: '#374151' }}>
            Registrar Nova Despesa Operacional
          </span>
        </div>

        <div style={{ padding: '20px 24px' }}>
          <form onSubmit={handleSalvar}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
              gap: '14px',
              marginBottom: '14px',
            }}>
              {/* Categoria */}
              <div>
                <FieldLabel required>Categoria</FieldLabel>
                <select
                  style={{ ...inputStyle, appearance: 'auto' }}
                  name="categoria"
                  value={novaDespesa.categoria}
                  onChange={handleChange}
                  required
                  {...focusHandlers}
                >
                  {CATEGORIAS.map(c => (
                    <option key={c.value} value={c.value}>{c.label}</option>
                  ))}
                </select>
              </div>

              {/* Data */}
              <div>
                <FieldLabel required>Data da Despesa</FieldLabel>
                <input
                  style={inputStyle}
                  type="date"
                  name="data_despesa"
                  value={novaDespesa.data_despesa}
                  onChange={handleChange}
                  required
                  {...focusHandlers}
                />
              </div>

              {/* Valor */}
              <div>
                <FieldLabel required>Valor (R$)</FieldLabel>
                <input
                  style={inputStyle}
                  type="number"
                  step="0.01"
                  name="valor"
                  placeholder="0,00"
                  value={novaDespesa.valor}
                  onChange={handleChange}
                  required
                  {...focusHandlers}
                />
              </div>
            </div>

            {/* Descrição */}
            <div style={{ marginBottom: '18px' }}>
              <FieldLabel>Descrição (Opcional)</FieldLabel>
              <textarea
                style={{ ...inputStyle, resize: 'vertical', minHeight: '64px' }}
                name="descricao"
                placeholder="Detalhes da despesa..."
                value={novaDespesa.descricao}
                onChange={handleChange}
                {...focusHandlers}
              />
            </div>

            {/* Botão salvar */}
            <button
              type="submit"
              disabled={isSavingDespesa}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '7px',
                padding: '9px 20px', borderRadius: '8px', border: 'none',
                background: isSavingDespesa
                  ? '#93c5fd'
                  : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
                color: '#fff',
                cursor: isSavingDespesa ? 'not-allowed' : 'pointer',
                fontSize: '13px', fontWeight: '600', fontFamily: 'inherit',
                boxShadow: isSavingDespesa ? 'none' : '0 2px 8px rgba(37,99,235,0.3)',
                transition: 'all 0.15s',
              }}
            >
              {isSavingDespesa
                ? <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
                : <Icon d={ICONS.plus} size={14} color="#fff" />
              }
              {isSavingDespesa ? 'Salvando...' : 'Salvar Despesa'}
            </button>
          </form>
        </div>
      </div>

      {/* ── TABELA: DESPESAS LANÇADAS ── */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px',
        border: '1px solid #e5e7eb', overflow: 'hidden',
      }}>
        {/* Cabeçalho */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 20px', borderBottom: '1px solid #e5e7eb',
          background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Icon d={ICONS.empty} size={15} color="#2563eb" />
            <span style={{ fontSize: '13px', fontWeight: '700', color: '#374151' }}>
              Despesas Lançadas Recentemente
            </span>
            {despesasLancadas.length > 0 && (
              <span style={{
                fontSize: '11px', fontWeight: '700', color: '#2563eb',
                backgroundColor: '#eff6ff', padding: '2px 8px',
                borderRadius: '999px', border: '1px solid #bfdbfe',
              }}>
                {despesasLancadas.length}
              </span>
            )}
          </div>
          <button
            onClick={fetchDespesasLancadas}
            disabled={isLoadingDespesasLancadas}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              padding: '6px 12px', borderRadius: '7px',
              border: '1px solid #e5e7eb', backgroundColor: '#fff',
              color: '#374151', fontSize: '12px', fontWeight: '600',
              cursor: isLoadingDespesasLancadas ? 'not-allowed' : 'pointer',
              opacity: isLoadingDespesasLancadas ? 0.6 : 1,
              fontFamily: 'inherit', transition: 'all 0.15s',
            }}
          >
            {isLoadingDespesasLancadas
              ? <Spinner as="span" animation="border" size="sm" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />
              : <Icon d={ICONS.refresh} size={12} color="#374151" />
            }
            Atualizar
          </button>
        </div>

        {/* Conteúdo */}
        {isLoadingDespesasLancadas ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '50px', gap: '12px' }}>
            <Spinner animation="border" variant="primary" style={{ width: '28px', height: '28px' }} />
            <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>Carregando despesas...</p>
          </div>
        ) : despesasLancadas.length === 0 ? (
          <div style={{ padding: '50px 24px', textAlign: 'center' }}>
            <Icon d={ICONS.empty} size={32} color="#d1d5db" />
            <p style={{ margin: '10px 0 0', fontSize: '13px', color: '#9ca3af', fontWeight: '500' }}>
              Nenhuma despesa lançada recentemente.
            </p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="desp-table">
              <thead>
                <tr>
                  <th className="hide-xs">Data</th>
                  <th>Categoria</th>
                  <th className="hide-sm">Descrição</th>
                  <th style={{ textAlign: 'right' }}>Valor</th>
                  <th style={{ textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {despesasLancadas.map(despesa => (
                  <tr key={despesa.id}>
                    {/* Data */}
                    <td className="hide-xs" style={{ color: '#6b7280', fontSize: '12px', fontFamily: 'monospace' }}>
                      {new Date(despesa.data_despesa).toLocaleDateString('pt-BR')}
                    </td>

                    {/* Categoria */}
                    <td>
                      <span style={{
                        fontSize: '11px', fontWeight: '700', padding: '2px 8px', borderRadius: '999px',
                        backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0',
                        whiteSpace: 'nowrap',
                      }}>
                        {formatCategoria(despesa.categoria)}
                      </span>
                    </td>

                    {/* Descrição */}
                    <td className="hide-sm" style={{ color: '#6b7280', maxWidth: '200px' }}>
                      <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {despesa.descricao || <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>—</span>}
                      </span>
                    </td>

                    {/* Valor */}
                    <td style={{ textAlign: 'right', fontWeight: '700', color: '#dc2626' }}>
                      {formatCurrency(despesa.valor)}
                    </td>

                    {/* Ações */}
                    <td style={{ textAlign: 'center' }}>
                      <button
                        onClick={() => onDeleteClick(despesa)}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: '4px',
                          padding: '5px 10px', borderRadius: '6px',
                          border: '1px solid #fecaca', backgroundColor: '#fef2f2',
                          color: '#dc2626', fontSize: '12px', fontWeight: '600',
                          cursor: 'pointer', fontFamily: 'inherit',
                          transition: 'background 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#fee2e2'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fef2f2'}
                        title="Excluir despesa"
                      >
                        <Icon d={ICONS.trash} size={11} color="#dc2626" />
                        <span className="hide-sm">Excluir</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default LancamentoDespesasTab;
